import {Component, Input} from '@angular/core';
import { navigation } from './../../_nav';
import {Router} from "@angular/router";
@Component({
  selector: 'app-sidenav-nav',
  template: `
    <mat-nav-list fxLayout="column">
      <mat-list-item style="height:64px">
        <img src="../assets/img/LogoNuresp.png" style="height:100%">
      </mat-list-item>
      <!--<mat-list-item>-->
        <!--<a href="general">Visão Geral</a>-->
        <!--<mat-divider [inset]="true"></mat-divider>-->
      <!--</mat-list-item>-->
      <!---->
        <!--<p style="padding-left: 10px">CONTROLE</p>-->
      <!--<mat-divider ></mat-divider>-->
      <a mat-list-item routerLink="/clients" *ngIf="userType === 'partner'">
        <mat-icon matListIcon>group</mat-icon>
        <a matLine> Clientes</a>
      </a>
      <a mat-list-item routerLink="/partners" *ngIf="userType === 'admin'" >
        <mat-icon matListIcon>group</mat-icon>
        <a matLine > Parceiros</a>
      </a>
      <a mat-list-item routerLink="/devices">
        <mat-icon matListIcon>settings</mat-icon>
        <a matLine > Aparelhos</a>
      </a>
      <!--<div *ngIf="isTitle(navItem)">-->
        <!--{{navItem.title}}-->
      <!--</div>-->
      <!--<ng-container [ngIf]="isDivider(navItem)">-->
        <!--<mat-divider [inset]="true"></mat-divider>-->
      <!--</ng-container>-->
      <!--<ng-container [ngIf]="hasIcon(navItem)">-->
      <!--<mat-icon matListIcon>folder</mat-icon>-->
      <!--</ng-container>-->
      <!--<a matLine href="{{navItem.url}}">{{ navItem.name }}</a>-->
    </mat-nav-list>`
})
export class AppSideNavNavComponent {
  @Input() userType: string;
  // public navigation = navigation;
  // public links = ['link1','link2','link3','link4'];

  // public isDivider(item) {
  //   return item.divider ? true : false
  // }
  // public isLink(item) {
  //   item.url ? true : false
  // }
  // public hasIcon(item) {
  //   item.icon ? true : false
  // }
  // public isTitle(item) {
  //   return item.title ? true : false
  // }
  // nav(route) {
  //   this.router.navigate(route).then(resp => console.log('navr',resp)).catch(err=> console.log('naverr',err));
  // }

  constructor(private router: Router) { }
}



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/components/app-sidenav-nav/app-sidenav-nav.component.ts